import { createContext, useState } from "react";

const MyContext = createContext();
const MyContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [theme, setTheme] = useState(localStorage.getItem("theme"));

  const [clientDetails, setClientDetails] = useState(
    JSON.parse(localStorage.getItem("clientDetails") || "{}")
  );
  const [permissions, setPermissions] = useState(
    JSON.parse(localStorage.getItem("permissions") || "{}")
  );

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("userDetails") || "{}")
  );

  const [counter, setCounter] = useState(localStorage.getItem("counter") || 0);
  const [selectedCourt, setSelectedCourt] = useState(
    localStorage.getItem("selectedCourt")
  );
  const [selectedVenue, setSelectedVenue] = useState(
    JSON.parse(localStorage.getItem("selectedVenue") || "{}")
  );

  const [selectedSport, setSelectedSport] = useState(
    JSON.parse(localStorage.getItem("selectedSport") || "{}")
  );

  const [selectedLocation, setSelectedLocation] = useState(
    JSON.parse(
      localStorage.getItem("selectedLocation") ||
        '{"locationid": 1, "name": "Vadodara"}'
    )
  );

  const [bookingUsername, setBookingUsername] = useState(
    localStorage.getItem("bookingUsername") || ""
  );
  const [bookingPhonenumber, setBookingPhonenumber] = useState(
    localStorage.getItem("bookingPhonenumber") || ""
  );

  const updateSelectedCourt = (newData) => {
    console.log("newData: ", newData);
    setSelectedCourt(newData);
    localStorage.setItem("selectedCourt", newData);
  };
  const updateSelectedSport = (newData) => {
    setSelectedSport(newData);
    localStorage.setItem("selectedSport", JSON.stringify(newData));
  };
  const updateSelectedLocation = (newData) => {
    setSelectedLocation(newData);
    localStorage.setItem("selectedLocation", JSON.stringify(newData));
  };

  const updateSelectedVenue = (newData) => {
    setSelectedVenue(newData);
    localStorage.setItem("selectedVenue", JSON.stringify(newData));
  };
  const updateCounter = (newData) => {
    setCounter(newData);
    localStorage.setItem("counter", newData);
  };

  const updateUser = (newData) => {
    setUser(newData);
    localStorage.setItem("userDetails", JSON.stringify(newData));
  };

  const updateRole = (newData) => {
    setRole(newData);
    localStorage.setItem("role", newData);
  };
  const updateBookingUsername = (newData) => {
    setBookingUsername(newData);
    localStorage.setItem("bookingUsername", newData);
  };
  const updateBookingPhonenumber = (newData) => {
    setBookingPhonenumber(newData);
    localStorage.setItem("bookingPhonenumber", newData);
  };

  const updateTheme = (newData) => {
    setTheme(newData);
    localStorage.setItem("theme", newData);
  };

  const updateToken = (newData) => {
    console.log("newData: ", newData);
    setToken(newData);
    localStorage.setItem("token", newData);
  };

  const updateClient = (newData) => {
    setClientDetails(newData);
    localStorage.setItem("clientDetails", JSON.stringify(newData));
  };
  const updatePermissions = (newData) => {
    setPermissions(newData);
    localStorage.setItem("permissions", JSON.stringify(newData));
  };

  return (
    <MyContext.Provider
      value={{
        loading,
        token,
        role,
        user,
        clientDetails,

        updateUser,
        updateRole,
        updateToken,
        updateClient,

        setLoading,
        theme,
        updateTheme,
        isMenuExpanded,
        setIsMenuExpanded,
        updatePermissions,
        permissions,

        selectedVenue,
        updateSelectedVenue,
        selectedCourt,
        updateSelectedCourt,
        selectedSport,
        updateSelectedSport,
        counter,
        updateCounter,

        updateBookingUsername,
        bookingUsername,

        updateBookingPhonenumber,
        bookingPhonenumber,
        selectedLocation,
        updateSelectedLocation,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export { MyContext, MyContextProvider };
